import axios from "axios";
import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { baseImgURL, baseURL } from "./backend/baseData";
import { toast } from "react-toastify";

const TaskRelation = () => {
  const params = useParams();
  const [tasks, setTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [taskOrder, setTaskOrder] = useState([]);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getUnpublishedTasks.php?challenge_id=${params.id}`
        );
        if (response.status === 200 && Array.isArray(response.data)) {
          //   console.log(response.data);
          setTasks(response.data);
          // Initialize task order based on initial task order
          setTaskOrder(
            response.data.map((task, index) => ({
              task_id: task.task_id,
              order_id: index + 1,
              challenge_id: params.id,
            }))
          );
        } else {
          console.error("Invalid response format or failed to fetch tasks");
          setTasks([]);
        }
      } catch (error) {
        console.error("Error while fetching tasks:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTasks();
  }, []);

  const handleDragStart = (event, index) => {
    event.dataTransfer.setData("index", index.toString());
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const newIndex = parseInt(event.currentTarget.getAttribute("data-index"));
    const oldIndex = parseInt(event.dataTransfer.getData("index"));

    // Create a copy of tasks array to avoid mutating state directly
    const updatedTasks = [...tasks];

    // Remove the item from its old position
    const draggedItem = updatedTasks.splice(oldIndex, 1)[0];

    // Insert the item at the new position
    updatedTasks.splice(newIndex, 0, draggedItem);

    // Update the tasks state
    setTasks(updatedTasks);

    // Update task order based on updated tasks array
    setTaskOrder(
      updatedTasks.map((task, index) => ({
        task_id: task.task_id,
        order_id: index + 1,
        challenge_id: params.id,
      }))
    );
  };
  console.log(taskOrder);
  const handlePublish = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/createRelation.php`,
        {
          orders: taskOrder,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (response.status === 200) {
        const notify = () => {
            toast.success('Relation Created Successfully!');
          };
        notify();
        return(
            <Navigate to="/challenges" replace={true} />
        )
        }
      // Optionally, you can handle success message or other UI updates here
    } catch (error) {
      console.error("Error publishing task relation:", error.message);
      // Optionally, you can handle error message or UI updates here
    }
  };
  return (
    <div className="w-full flex-grow p-3">
      <div>Drag and drop  to reorder tasks</div>
      <div
        className="w-full items-center flex flex-col"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        {tasks.length > 0 &&
          taskOrder.map((item, index) => {
            return (
              <div
                key={index}
                draggable
                onDragStart={(event) => handleDragStart(event, index)}
                className="w-fit col-span-12 md:col-span-6 max-h-24 mb-6 mt-2 draggable-item"
                data-index={index}
              >
                <div className="bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 grid grid-cols-12">
                  <div className="col-span-4 p-3">
                    <img
                      className="rounded-md w-20 object-cover max-h-20 h-full"
                      src={baseImgURL + tasks[index].image}
                      alt={tasks[index].task_name}
                    />
                  </div>
                  <div className="p-5 col-span-8">
                    <div>
                      <h5 className="mb-2 text-lg font-bold tracking-tight text-gray-900 dark:text-white">
                        {tasks[index].task_name}
                      </h5>
                    </div>
                    <p className="mb-3 font-normal text-gray-700 dark:text-gray-400 text-sm">
                      {tasks[index].type}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        <div className="mt-5">
          <button className="bg-blue-500 p-4 rounded-md text-white" onClick={handlePublish}>
            Publish
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskRelation;
